export const sk = {
  returnLineItems: {
    refund: "Vrátenie peňazí",
    exchange: "Výmena",
    discount: "Zľava",
  },
  returnStoreAddress: {
    mapButton: "Zobraziť na mape",
  },
  downloadLabel: {
    label: "Stiahnuť môj štítok",
    bonDeRetour: "Stiahnuť formulár na vrátenie",
  },
  returnRequestDate: {
    label: "Vaša žiadosť o vrátenie bola podaná {{date}} o {{time}}",
  },
  actions: {
    continue: "Pokračovať",
  },
  "order-identification": {
    title: "Sledujte svoju objednávku",
    description: "Zadajte údaje o objednávke pre sledovanie zásielky",
    fields: {
      "zip-code": {
        title: "PSČ",
        description: "Zadajte vaše doručovacie PSČ",
        required: "PSČ je povinné",
      },
      "tracking-number": {
        title: "Číslo objednávky",
        description: "Zadajte číslo vašej objednávky",
        required: "Číslo objednávky je povinné",
      },
    },
    errors: {
      "unknown-order": {
        title: "Neznáme číslo objednávky",
        description: "Číslo objednávky nebolo nájdené, skontrolujte ho prosím",
      },
      "search-error": {
        title: "Chyba vyhľadávania",
        description:
          "Nepodarilo sa nám nájsť objednávku. Skúste to prosím neskôr.",
      },
    },
  },
  delivery: "Doručenie",
  "parcel-history": "História balíka",
  "order-details": {
    title: "Detaily objednávky",
    "tracking-number": "Sledovacie číslo",
    "order-number": "Číslo objednávky",
  },
  tracking: {
    shared: {
      estimatedDeliveryDate: "Odhadovaný dátum doručenia",
      deliveredOn: "Doručené dňa",
      from: "od",
      to: "do",
    },
  },
  deliveryAddress: {
    title: "Dodacia adresa:",
    titlePickup: "Adresa výdajného miesta:",
    orderDetails: {
      title: "Detaily objednávky:",
      trackingNumber: "Sledovacie číslo:",
      orderNumber: "Číslo objednávky:",
      orderDate: "Dátum objednávky:",
    },
  },
  pickupPoint: {
    title: "Výdajné miesto",
    openingHours: "Otváracie hodiny:",
    closed: "Zatvorené",
    directions: "Trasa",
    days: {
      monday: "Pondelok:",
      tuesday: "Utorok:",
      wednesday: "Streda:",
      thursday: "Štvrtok:",
      friday: "Piatok:",
      saturday: "Sobota:",
      sunday: "Nedeľa:",
    },
  },
  wallet: {
    warningNotEnabled: "Musíte povoliť Wallet v nastaveniach svojho obchodu",
  },
  crossSell: {
    youMightAlsoLike: "Mohlo by sa vám tiež páčiť",
  },
  "rate-order": {
    "order-recap": {
      title: "Vaša objednávka",
      "tracking-label": "Sledovacie číslo:",
      "order-label": "Číslo objednávky:",
    },
    form: {
      title: "Ohodnoťte svoje doručenie",
      "rating-label": "Ohodnoťte svoj zážitok z doručenia",
      "comment-label": "Komentár (nepovinné)",
      "comment-placeholder": "Podeľte sa s nami o svoj zážitok…",
      "submit-cta": "Odoslať hodnotenie",
      "update-cta": "Aktualizovať hodnotenie",
      "rating-required": "Vyberte prosím hodnotenie.",
    },
    "thank-you": {
      title: "Ďakujeme za vašu spätnú väzbu!",
      description:
        "Vaše hodnotenie bolo uložené. Pomôže nám zlepšiť zážitok z doručenia.",
    },
    errors: {
      "invalid-token": {
        title: "Neplatný alebo vypršaný odkaz",
        description:
          "Tento odkaz už nie je platný. Otvorte ho prosím znova z vášho posledného sledovacieho e-mailu.",
      },
      submit: {
        title: "Niečo sa pokazilo",
        description:
          "Nepodarilo sa nám uložiť vaše hodnotenie. Skúste to prosím neskôr.",
      },
    },
  },
} as const;
